<template>
  <div @blur="open = false" class="location">
    <InputText
      ref="input"
      v-model="val"
      :placeholder="placeholder"
      @input="getSuggestAddress"
    />
    <div v-if="open && options.length" class="location_select">
      <perfect-scrollbar>
        <div
          v-for="(v, i) in options"
          v-show="v.street"
          :key="`location-option-${ i }`"
          @click="changeOption(v)"
          class="location_option"
        >
          {{ v.street }}
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import InputText from '@/components/UI/InputText'
import _ from 'lodash'

export default {
  components: { InputText },
  props: {
    setCity: {
      type: Function,
    },
    placeholder: String,
    default: {
      type: String,
      required: false,
      default: null,
    },
  },
  data () {
    return {
      val: '',
      selected: null,
      open: false,
      options: [],
    }
  },
  created () {
    this.selected = this.default
      ? this.default
      : this.options.length > 0
        ? this.options[0]
        : null

    if (this.default) {
      this.faker = true
      this.val = this.default
      setTimeout(() => {
        this.faker = false
      }, 400)
    }
  },
  methods: {
    getSuggestAddress: _.debounce(function (value) {
      if (value.length >= 3) {
        this.$store.dispatch('common/getSuggestAddress', value).then((res) => {
          res.length ? this.open = true : this.open = false
          this.options = res
          if (res.length === 1) {
            this.$emit('setCity', res[0].city)
          }
        })
          .catch(err => console.error('location input - common/getSuggestAddress - error', err))
      }
    }),
    changeOption (value) {
      this.selected = value.street
      this.open = false
      this.options = []
      this.val = value.street
      this.$emit('input', value.street)
      this.$emit('setCity', value.city)
    },
  },
}
</script>

<style lang="less">
.location {
	width: 100%;
	position: relative;

	&_selected {
		background-color: #f2f2f2;
		font-family: 'Roboto', Arial, sans-serif;
		font-weight: normal;
		font-size: 14px;
		color: black;
		position: absolute;
		top: 4px;
		left: 17px;
		cursor: text;
	}

	.input-text { z-index: 2; }

	&_select {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: stretch;
		background-color: #f2f2f2;
		padding-top: 20px;
		padding-bottom: 15px;
		border-bottom-left-radius: 15px;
		border-bottom-right-radius: 15px;
		position: absolute;
		top: calc(100% - 12px);
		left: 0;
		z-index: 1;

		.ps {
			max-height: 150px;
		}
	}

	&_option {
		width: 100%;
		padding: 14px 17px;
		font-family: 'Roboto', Arial, sans-serif;
		font-weight: normal;
		font-size: 14px;
		color: black;
		transition: background-color .25s;
		cursor: pointer;

		&:hover {
			background-color: #e6e6e6;
		}
	}
}
</style>
